module.exports = __webpack_public_path__ + "static/media/paleta.61c3c956.jpeg";